<template lang="pug">
  v-container.px-5.py-0(style="max-width: 600px")
    v-card.mb-4.rounded-xl(outlined, @click="redirectTo('/admin/hq/settings/account')")
      v-card-text.d-flex.align-center.py-4
        v-icon.mr-4(color="primary" size="24") $yzi-user-01
        .d-flex.flex-column
          .text-md.font-medium.neutral700--text {{ $t('account_settings') }}
          .text-sm.neutral500--text Manage your profile and account preferences
        v-spacer
        v-icon(color="neutral400" size="20") mdi-chevron-right

    v-card.mb-4.rounded-xl(outlined, :href="changeCompanyUrl()")
      v-card-text.d-flex.align-center.py-4
        v-icon.mr-4(color="primary" size="24") mdi-swap-horizontal
        .d-flex.flex-column
          .text-md.font-medium.neutral700--text Switch company
          .text-sm.neutral500--text Switch between your companies
        v-spacer
        v-icon(color="neutral400" size="20") mdi-chevron-right

    v-card.mb-4.rounded-xl(outlined, @click="redirectTo('/admin/hq/patients')")
      v-card-text.d-flex.align-center.py-4
        v-icon.mr-4(color="primary" size="24") $yzi-users-02
        .d-flex.flex-column
          .text-md.font-medium.neutral700--text Patient records
          .text-sm.neutral500--text Patient information & medical records
        v-spacer
        v-icon(color="neutral400" size="20") mdi-chevron-right

    v-card.rounded-xl(outlined, :href="logoutUrl()")
      v-card-text.d-flex.align-center.py-4
        v-icon.mr-4(color="primary" size="24") $yzi-log-out-01
        .d-flex.flex-column
          .text-md.font-medium.neutral700--text {{ $t('log_out') }}
          .text-sm.neutral500--text Sign out of your account
        v-spacer
        v-icon(color="neutral400" size="20") mdi-chevron-right
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'HQSettings',
  computed: {
    ...mapState('user', ['member'])
  },
  methods: {
    redirectTo(route) {
      this.$router.push(route).catch(() => {
      })
    },
    logoutUrl() {
      let link = '/signout'
      if (this.member.username) {
        link += '?username=true'
      }
      return link
    },
    changeCompanyUrl () {
      return '/companies'
    }
  }
}
</script>

<style scoped>
.v-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
  transition: box-shadow 0.2s ease-in-out;
}
</style>